import React from 'react'
import LibroQuejasPage from '../components/templates/LibroQuejasTemplate'

const LibroQuejas = () => {
  return (<LibroQuejasPage />
  )
}

export default LibroQuejas
